import { useState } from "react";
import { Link } from "react-router-dom";
import { ListChecks, Youtube, FileSpreadsheet, Loader2, Palmtree } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import YoungGrades from "@/components/admin/YoungGrades";

const SUBJECTS = ["Maths", "English", "French", "Science", "History & Geography", "SSEE", "Health & Physical Education"];

export default function ContentTools() {
  const [busy, setBusy] = useState("");
  const download = async (subject) => {
    setBusy(subject);
    try {
      const { data } = await api.get("/admin/questions/export", { params: { subject }, responseType: "blob" });
      const url = URL.createObjectURL(data);
      const name = `anou-appran-${subject.toLowerCase().replace(/ & /g, "-").replace(/ /g, "-")}-questions.xlsx`;
      Object.assign(document.createElement("a"), { href: url, download: name }).click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error(`Could not download the ${subject} Excel file.`);
    } finally {
      setBusy("");
    }
  };
  return (
    <div className="bg-slate-800 rounded-2xl border-2 border-blue-400/60 p-4 mb-6" data-testid="admin-content-tools">
      <div className="flex flex-wrap items-center gap-2">
        <p className="font-bold mr-2">Content tools (admin only)</p>
        <Link to="/admin/review" data-testid="admin-open-review" className="inline-flex items-center gap-1.5 rounded-full bg-blue-500 hover:bg-blue-400 px-3 py-1.5 text-sm font-semibold"><ListChecks size={15} /> Question review (QA)</Link>
        <Link to="/admin/holiday-pack" data-testid="admin-open-holiday-pack" className="inline-flex items-center gap-1.5 rounded-full bg-orange-500 hover:bg-orange-400 px-3 py-1.5 text-sm font-semibold"><Palmtree size={15} /> Holiday Pack questions</Link>
        <Link to="/admin/videos" data-testid="admin-open-videos" className="inline-flex items-center gap-1.5 rounded-full bg-red-500 hover:bg-red-400 px-3 py-1.5 text-sm font-semibold"><Youtube size={15} /> Chapter videos</Link>
      </div>
      <div className="flex flex-wrap items-center gap-2 mt-3 text-sm">
        <span className="text-slate-400">Download questions, Grades 1–6 (Excel):</span>
        {SUBJECTS.map((s) => (
          <button key={s} onClick={() => download(s)} disabled={!!busy} data-testid={`admin-export-${s.toLowerCase().replace(/ & /g, "-").replace(/ /g, "-")}`}
            className="inline-flex items-center gap-1 rounded-full border-2 border-slate-600 px-3 py-1 hover:bg-slate-700 disabled:opacity-60">
            {busy === s ? <Loader2 size={13} className="animate-spin" /> : <FileSpreadsheet size={13} className="text-emerald-300" />} {s}
          </button>
        ))}
      </div>
      <YoungGrades />
    </div>
  );
}
